import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=1fd5da46"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports